
import { of as observableOf, Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserService } from '_services/user.service';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { WelcomeService } from '_services/welcome.service';
import { schoolIdFromRoute } from '_services/route-school-id';
import { filter, take, map, tap, switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ProgressGuard {
  private we = inject(WelcomeService);
  private userService = inject(UserService);
  private ups = inject(UnivPrefsService);
  private router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean> {

    const schoolId = schoolIdFromRoute(next) || this.userService.schoolId || '';

    return this.userService.user.pipe(
      filter(user => !!user),
      take(1),
      // First we need to check for a user...
      tap(_user => {
        if (schoolId) {
          this.userService.schoolId = schoolId;
        }
      }),
      switchMap(_user => {
        if (!this.ups.isLoaded()) {
          return this.we.loadSchool(schoolId).pipe(map(_x => true));
        } else {
          return observableOf(true);
        }
      })
    );
  }
}

